import React from "react";

import Applet from "../../Applet";
import ProjectPlanAuditLogTable from "../../../../components/ProjectPlan/ProjectPlanAuditLogTable";

class ProjectMilestoneAuditHistoryTableApplet extends Applet {

    render() {
        return <ProjectPlanAuditLogTable applet={this}
                                 pageSize={this.props.PageSize ? this.props.PageSize : this.state.PageSize}
                                 placement={this.state.Placement}
                                 columns={this.state.Columns}
                                 title="Session Audit History"
                                 enterpriseComponent={this.getEnterpriseComponent()}
                                 sort={this.state.Sort}
                                 menu={this.state.Menu}
                                 rowHeight={this.state.RowHeight}
                                 simpleSearch={this.state.SimpleSearch}
                               // enableSort={true}
                               // enableSearch={true}

        />;
    }

    state = {
        Name: "ProjectMilestoneAuditHistoryTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 340,
        PageSize: {
            "default": 20,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "Column1",
                },
                {
                    id: "Column2",
                },
                {
                    id: "Change",
                }
            ]
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "Column1",
                width: 300,
                cellRenderer: "Column1 Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Performed On/By",
            },
            {
                id: "Column2",
                width: 200,
                cellRenderer: "Column2 Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Type",
            },
            {
                id: "Change",
                width: 800,
                cellRenderer: "Content Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Content",
            },
        ],
        Sort: [
        ],
    }
}

export default ProjectMilestoneAuditHistoryTableApplet;
